class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
  }

  onChange() {
    const searchTerm = (this.input.value || '').trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;

        // Render Shopify’s standard predictive results
        this.predictiveSearchResults.innerHTML = resultsMarkup;

        // ➕ Append Blogs section derived from our JSON
        this.appendBlogsToResults(this.input?.value || '');

        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  /**
   * Reads blog list from <script id="ps-blogs-json">,
   * matches titles against the query, and appends a "Blogs" section.
   */
  appendBlogsToResults(query) {
    const dataEl = document.getElementById('ps-blogs-json');
    if (!dataEl) return;
  
    let blogs = [];
    try {
      blogs = JSON.parse(dataEl.textContent || '[]');
    } catch (_) {
      return;
    }
  
    const q = (query || '').trim().toLowerCase();
    if (!q) return;
  
    // sort by where the match appears (earlier = better), then alphabetically
    const matches = blogs
      .filter(b => (b.title || '').toLowerCase().includes(q))
      .map(b => ({ ...b, _idx: (b.title || '').toLowerCase().indexOf(q) }))
      .sort((a, b) => (a._idx - b._idx) || a.title.localeCompare(b.title));
  
    if (!matches.length) return;
  
    const container = this.predictiveSearchResults || document.getElementById('predictive-search');
    if (!container) return;
  
    // remove any previous blogs block so it doesn't stack
    const old = container.querySelector('.predictive-search__blogs');
    if (old) old.remove();
  
    const maxItems = 6; // tweak if you want fewer/more
    const visible = matches.slice(0, maxItems);
  
    const wrapper = document.createElement('div');
    wrapper.className = 'predictive-search__blogs';
    wrapper.innerHTML = `
      <h3 class="predictive-search__heading" style="margin-top:1rem;">Blogs</h3>
      <ul class="predictive-search__list" role="list">
        ${visible.map(b => `
          <li class="predictive-search__item">
            <a class="predictive-search__item-link" href="${b.url}">
              <span class="predictive-search__item-heading">${this.escapeHTML(b.title)}</span>
              ${Number.isFinite(b.articles_count) ? `<span class="predictive-search__item-meta">${b.articles_count} articles</span>` : ``}
            </a>
          </li>
        `).join('')}
      </ul>
    `;
    container.appendChild(wrapper);
  }
  

  // Mini HTML escaper for safety
  escapeHTML(str) {
    return String(str)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
